// removed by extract-text-webpack-plugin
module.exports = {"orderSummary":"_3eno1","open":"_1NlJO","orderItems":"_2AOCl"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Checkout/OrderSummary/index.sass
// module id = 1468
// module chunks = 1